import { CombinedVueInstance } from 'vue/types/vue';
import { Store } from 'vuex';

import { stringifyError } from './stringifyError';

/**
 * Pokazuje listę błędów w formie okna do zamknięcia
 *
 * @export
 * @param {Store<any>} store
 * @param {Array<{ entityId: number; error: any }>} errors
 * @return {void}
 */
export function showErrorsDialog(
  store: Store<any>,
  title: string,
  errors: Array<{ entityId: number; error: any }>
): Promise<void> {
  const resultAsLi = errors
    .map(error => {
      return `<li><b>ID: ${error.entityId}</b>: ${stringifyError(error.error)}</li>`;
    })
    .join('');
  const description = '<ul>' + resultAsLi + '</ul>';

  return store
    .dispatch('setConfirm', {
      description,
      showCloseButton: false,
      title,
      submitButton: 'Ok'
    })
    .then(() => undefined);
}
